import { render, staticRenderFns } from "./SpecialOffer.vue?vue&type=template&id=d2071d64&scoped=true&"
import script from "./SpecialOffer.vue?vue&type=script&lang=js&"
export * from "./SpecialOffer.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOffer.vue?vue&type=style&index=0&id=d2071d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2071d64",
  null
  
)

export default component.exports